import React from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import AutoComplete from '@/shared/components/input/select/AutoComplete';
import EditableToggle from './EditableToggle';

const EditableAutoComplete = ({
  onChange,
  value,
  disabled,
  submitOnChange,
  className,
  displayValue,
  required,
  ...rest
}) => (
  <EditableToggle
    onSubmit={onChange}
    value={value}
    readOnly={disabled}
    displayValue={displayValue(value)}
    className={className}
  >
    {({ inputValue, setInputValue, submit, inputRef }) => (
      <OutsideClickHandler onOutsideClick={submit}>
        <AutoComplete
          onChange={e => {
            if (!e && required) return;
            if (submitOnChange && !!e) {
              setInputValue(e).then(submit);
            } else {
              setInputValue(e);
            }
          }}
          disabled={disabled}
          mode="edit"
          value={inputValue}
          inputRef={inputRef}
          {...rest}
        />
      </OutsideClickHandler>
    )}
  </EditableToggle>
);
EditableAutoComplete.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.shape({ id: PropTypes.string.isRequired }),
    PropTypes.string,
  ]),
  disabled: PropTypes.bool,
  submitOnChange: PropTypes.bool,
  intl: intlShape.isRequired,
  className: PropTypes.string,
};

EditableAutoComplete.defaultProps = {
  value: null,
  disabled: false,
  submitOnChange: false,
  className: '',
};

export default injectIntl(EditableAutoComplete);
